/* eslint-disable no-nested-ternary */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
import moment from 'moment';
import { useState } from 'react';
import { connect } from 'react-redux';

import CheckboxField from '../../../../../primitives/form/CheckboxField/CheckboxField';
import DateField from '../../../../../primitives/form/DateField/DateField';
import SelectField from '../../../../../primitives/form/SelectField/SelectField';
import TextareaField from '../../../../../primitives/form/TextareaField/TextareaField';
import TextField from '../../../../../primitives/form/TextField/TextField';
import Tooltip from '../../../../../tooltip/Tooltip';
import { setFieldValue, updateFileReadyToUploadFlag } from '../../redux/files/actionCreators';
import { fieldDisabled } from '../../utils/display/display';

export function UploadFormField(props) {
  const {
    displayOnlyRequiredInfoFields,
    field,
    fileIndex,
    fieldIndex,
    setFieldValue,
    updateFileReadyToUploadFlag,
    fileStatus,
    value,
  } = props;

  // If displayOnlyRequiredInfoFields is set to true, skip displaying non-required fields
  if (displayOnlyRequiredInfoFields && !field.required) {
    return <div />;
  }

  const [validation, setValidation] = useState(false);
  const [date, setDate] = useState(null);
  const [calendarOpen, setCalendarOpen] = useState(false);

  const handleOnChange = (event, type) => {
    setFieldValue(
      fileIndex,
      fieldIndex,
      field,
      type === 'checkbox' ? (event.target.checked ? '1' : '0') : type === 'dropdown' ? event : event.target.value,
    );

    updateFileReadyToUploadFlag(fileIndex);

    switch (type || null) {
      case 'dropdown':
        setValidation(field.required && !event);
        break;
      case 'checkbox':
        setValidation(field.required && !event.target.checked);
        break;
      default:
        break;
    }
  };

  const dateHandleOnChange = (dateToHandle) => {
    setFieldValue(fileIndex, fieldIndex, field, dateToHandle !== null ? moment(dateToHandle).format('YYYY-MM-DD') : '');

    updateFileReadyToUploadFlag(fileIndex);
    setDate(dateToHandle !== null ? dateToHandle : null);
    setValidation(false);
  };

  const handleOnBlur = (event, type) => {
    switch (type || null) {
      case 'checkbox':
        setValidation(field.required && !event.target.checked);
        break;
      case 'date':
        setValidation(field.required && date === null && !calendarOpen);
        break;
      default:
        setValidation(field.required && !event.target.value);
    }
  };

  const handleOnClick = () => {
    setValidation(false);
  };

  const calendarOnClose = () => {
    setCalendarOpen(false);
  };

  const calendarOnOpen = () => {
    setCalendarOpen(true);
    setValidation(field.required && false);
  };

  switch (field ? field.field_type : null) {
    case 'string':
      return (
        <div className="form__group-wrapper form__group-wrapper--half-on-desktop">
          <div className="form__group">
            <Tooltip
              triggerEvent="hover"
              activate={!!(field.placeholder || field.instructions)}
              title={field.placeholder}
              description={field.instructions}
            >
              <TextField
                showError={validation}
                errorMessage="This is a required field."
                fieldID={`${field.key}_${fileIndex}`}
                fieldText={field.name}
                fieldRequired={field.required}
                value={value}
                handleClick={handleOnClick}
                handleChange={handleOnChange}
                handleBlur={handleOnBlur}
                disabled={fieldDisabled(fileStatus)}
                autoComplete="off"
              />
            </Tooltip>
          </div>
        </div>
      );
    case 'text':
      return (
        <div className="form__group-wrapper form__group-wrapper--full">
          <div className="form__group">
            <Tooltip
              triggerEvent="hover"
              activate={!!(field.placeholder || field.instructions)}
              title={field.placeholder}
              description={field.instructions}
            >
              <TextareaField
                showError={validation}
                errorMessage="This is a required field."
                fieldID={`${field.key}_${fileIndex}`}
                fieldText={field.name}
                fieldRequired={field.required}
                value={value}
                handleClick={handleOnClick}
                handleChange={handleOnChange}
                handleBlur={handleOnBlur}
                disabled={fieldDisabled(fileStatus)}
              />
            </Tooltip>
          </div>
        </div>
      );
    case 'checkbox':
      return (
        <div className="form__group-wrapper form__group-wrapper--full">
          <div className="form__group">
            <Tooltip
              triggerEvent="hover"
              activate={!!(field.placeholder || field.instructions)}
              customClass="tooltip__container--reduced-width"
              title={field.placeholder}
              description={field.instructions}
            >
              <CheckboxField
                showError={validation}
                errorMessage="This is a required field."
                fieldID={`${field.key}_${fileIndex}`}
                optionText={field.name}
                fieldRequired={field.required}
                optionValue={value}
                handleClick={handleOnClick}
                handleChange={handleOnChange}
                handleBlur={handleOnBlur}
                disabled={fieldDisabled(fileStatus)}
                checked={value === '1'}
              />
            </Tooltip>
          </div>
        </div>
      );
    case 'date':
      return (
        <div className="form__group-wrapper form__group-wrapper--half-on-desktop">
          <div className="form__group">
            <Tooltip
              triggerEvent="hover"
              activate={!!(field.placeholder || field.instructions)}
              title={field.placeholder}
              description={field.instructions}
            >
              <DateField
                showError={validation}
                errorMessage="This is a required field."
                fieldID={`${field.key}_${fileIndex}`}
                fieldText={field.name}
                fieldRequired={field.required}
                dateFormat="dd/MM/yyyy"
                date={value ? moment(value).add(0, 's').toDate() : date}
                calendarOpen={calendarOpen}
                disabled={fieldDisabled(fileStatus)}
                handleChange={dateHandleOnChange}
                handleBlur={handleOnBlur}
                calendarOnClose={calendarOnClose}
                calendarOnOpen={calendarOnOpen}
              />
            </Tooltip>
          </div>
        </div>
      );
    case 'dropdown':
      return (
        <div className="form__group-wrapper form__group-wrapper--half-on-desktop">
          <div className="form__group">
            <Tooltip
              triggerEvent="hover"
              activate={!!(field.placeholder || field.instructions)}
              title={field.placeholder}
              description={field.instructions}
            >
              <SelectField
                showError={validation}
                errorMessage="This is a required field."
                fieldID={`${field.key}_${fileIndex}`}
                fieldText={field.name}
                fieldRequired={field.required}
                disabled={fieldDisabled(fileStatus)}
                handleClick={handleOnClick}
                handleBlur={handleOnBlur}
                handleChange={handleOnChange}
                options={field.dropdown_options}
                required
                value={value || ''}
              />
            </Tooltip>
          </div>
        </div>
      );
    default:
      return <div />;
  }
}

export const mapStateToProps = (state) => {
  return {
    displayOnlyRequiredInfoFields: state.internal.displayOnlyRequiredInfoFields,
  };
};

const mapDispatchToProps = (dispatch) => ({
  setFieldValue: (fileIndex, fieldIndex, field, value) => {
    dispatch(setFieldValue(fileIndex, fieldIndex, field, value));
  },
  updateFileReadyToUploadFlag: (fileIndex) => {
    dispatch(updateFileReadyToUploadFlag(fileIndex));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(UploadFormField);
